import type { FaireProductEntity } from "../../entity_types/product";

export const p_79eudmu4xs: FaireProductEntity = {
  token: "p_79eudmu4xs",
  type: "product",
  name: "ŐSIMAGNESIUM Bath Flakes - 7oz",
  brandToken: "b_eradtetzzl",
  brandName: "Healthy Energy Amazing Life",
  imageUrl:
    "https://cdn.faire.com/fastly/138f4598e3634eccc3a1d2d0a3d7738ca8757ba5cc29382ef2f2519c2360f5aa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3cde8e79ff8b03483a85c92aa0d027a45ff9a1d7f19becac12c1e21e238b694c.png",
    "https://cdn.faire.com/fastly/a3d4653ba69fbf8097e9289a6f318af0e0dfe1a98411e115521890842626ce09.png",
    "https://cdn.faire.com/fastly/5f006a12c7ac02d953d0d81ce1937493c6338f9f499cd7bdaf98013a75e2c945.png",
    "https://cdn.faire.com/fastly/2e1c6d228cb667142d8f8717461dfec6b59b99097b72f5fd901a3650cf4f3e59.png",
    "https://cdn.faire.com/fastly/532eaaadb0c5e4cac6217a8c41c6095e7ad57e33abc3b0f950980bc382e7fb46.png",
    "https://cdn.faire.com/fastly/70b5ec3f762adb6b75248320f9d4f78ccb1ff8f1286c01616125ca9db36d33f5.png",
    "https://cdn.faire.com/fastly/5fbb74601940cd249c81e9e584a68a37c7312c5fa1d288ddc153ee420c0847f3.jpeg",
    "https://cdn.faire.com/fastly/b8255e9abbbd007084dbf6ac6c340a464333eeaa91422c8724816e7146099e45.jpeg",
    "https://cdn.faire.com/fastly/05aa76a3caa6846242056be48e1b12690fecb36223bdf56bfaed5b1161694375.jpeg",
  ],
  priceDollars: 2.63,
  description:
    "Magnesium is an important mineral for a healthy lifestyle and an active life. Nevertheless, we typically do not get the amount of magnesium that our bodies need.\n\nŐSIMAGNESIUM is applied directly to the skin where it is absorbed directly into the body. ŐSIMAGNESIUM is:\n\n * Scientifically Proven \n * 100% Natural \n * Vegan \n * Cruelty Free \n * Silicone Free \n * Paraben Free \n * Optimal Transdermal Absorption \n * Extracted from the Untouched 250 Million Years Old Zechstein Sea \nŐSIMAGNESIUM Bath Flakes are made from the brine which is mined from the 250 million years old ancient Zechstein Seabed, from 1600 meter depth. These bath flakes are an effective and relaxing way to increase your body’s magnesium levels.",
  tags: [],
  msrpDollars: 3.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:08.898Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
